// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 1/11/2023
 */

 .DetailsStep_container__PYHMs {
    margin-top: 2rem;
    /* width: 1500px;
    margin-left: -170px;
    margin-right: -200px; */
}


.DetailsStep_paper__QGXK8 {
    padding: 1rem 1rem;
    background: linear-gradient(91deg, rgba(90, 155, 216, 0.1) 23.22%, rgba(90, 155, 216, 0) 99.28%);
}

.DetailsStep_detailsContainer__OTQDh {
    overflow: auto;
}
/* .detailsContainer::-webkit-scrollbar {
    display: none;
} */

.DetailsStep_topic__cg2Uj {
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 600;
    margin: 0 1.5rem 1.5rem 2.38rem;
}

.DetailsStep_textInput__-FWKx {
    border-radius: 0.5rem;
    background: #FFF;
    box-shadow: 2px 2px 50px 2px #657FAD1A;
}

.DetailsStep_subTitle__0bu3z {
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 400;
}

.DetailsStep_questionContainer__GgoDB {
    margin: 0 2.38rem;
    margin-bottom: 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.DetailsStep_line__cni-N {
    border-color:  rgba(255, 255, 255, 0.5);
    margin: 0;
}

.DetailsStep_itemContainer__d4DU- {
    padding: 1rem 2.38rem;
    display: flex;
    align-items: center;
    /* border-left: 0.3rem solid #f5edff; */
}

.DetailsStep_itemContainerSelected__WELdg {
    padding: 1.5rem 2.38rem;
    display: flex;
    align-items: center;
    border-radius: 0.5rem;
    background-color: #5a9bd860;
    /* border-left: 0.3rem solid #d7b8ff; */
}

.DetailsStep_addButton__ZiKZ1 {
    border-radius: 0.5rem;
    width: 8rem;
    /* margin-top: 5rem; */
}

.DetailsStep_itemImage__Tuaj1 {
    width: 7rem;
    object-fit: contain;
    margin-right: 2rem;
}

.DetailsStep_itemDescription__zoyz\\+ {
    font-size: 1rem;
    font-style: normal;
    font-weight: 300;
    margin: 1rem 0;
    width: 26rem;
}

.DetailsStep_itemPrice__rzBy3 {
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 500;
}

.DetailsStep_counter__K97x4 {
    color: maroon;
    display: inline-flex;
    margin-left: 2rem;
    height: 2.5rem;
}

/* .counter button {
    color: black;
    border-radius: 100%;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 500;
} */

.DetailsStep_instructionContainer__vSixb {
    margin: 0 2.38rem;
}

.DetailsStep_multiline__Lp4Id {
    margin: 3rem 0 1.5rem 0;
    border-radius: 0.5rem;
    background: #FFF;
    box-shadow: 2px 2px 50px 2px #657FAD1A;
}

.DetailsStep_frequencyContainer__Ikdbf {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.DetailsStep_frequencyCard__R1rQq {
    display: flex;
    flex-direction: column;
    color: black;
    border-radius: 0.5rem;
    background: linear-gradient(91deg, rgba(50, 115, 190, 0.2) 23.22%, rgba(50, 115, 190, 0) 99.28%);
    align-items: center;
    justify-content: center;
    padding: 0 2rem;
    margin: 1rem;
    margin-top: 0;
    height: 10rem;
    cursor: pointer;
    border: 1px solid #c5c5c5;
    text-align: center;
}

.DetailsStep_selectedFreq__0L2c8 {
    border: 0.2rem solid #5A9BD8;
}

.DetailsStep_frequencyDetails__aE6PU {
    font-size: 1rem;
    font-style: normal;
    font-weight: 300;
    margin: 0.5rem 0;
    width: 16.5rem;
}

.DetailsStep_frequencyOff__GUmk3 {
    color: #077965;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 600;
}

/* for mobile */
@media (max-width: 770px) {
    .DetailsStep_paper__QGXK8 {
        padding: 1.5rem 0;
        padding-top: 0;
        background: white;
    }
    .DetailsStep_topic__cg2Uj {
        font-size: 1.5rem;
        font-weight: 600;
        margin: 0 1.5rem 2rem 1rem;
    }
    .DetailsStep_questionContainer__GgoDB {
        margin: 0 1rem;
        margin-bottom: 0.5rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .DetailsStep_subTitle__0bu3z {
        font-size: 1rem;
    }
    .DetailsStep_textInput__-FWKx {
        margin-top: 1rem;
    }
    .DetailsStep_itemDescription__zoyz\\+ {
        width: 14rem;
        height: 3rem;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .DetailsStep_addButton__ZiKZ1 {
        position: absolute;
        right: 1.5rem;
        margin-top: 6rem;
        width: 5rem;
    }
    .DetailsStep_itemImage__Tuaj1 {
        width: 4rem;
    }
    .DetailsStep_itemPrice__rzBy3 {
        font-size: 1rem;
    }
    .DetailsStep_itemContainer__d4DU- {
        border-left: 0.3rem solid #ffffff;
        padding: 1rem 1.5rem;
        padding-left: 0.5rem;
    }
    .DetailsStep_itemContainerSelected__WELdg {
        padding: 1rem 1.5rem;
        padding-left: 0.5rem;
    }
    .DetailsStep_counter__K97x4 button {
        font-size: 1.25rem;
    }
    .DetailsStep_counter__K97x4 {
        height: 2rem;
    }
    .DetailsStep_frequencyCard__R1rQq {
        padding: 0.1rem;
        height: 7rem;
    }
    .DetailsStep_frequencyDetails__aE6PU {
        font-size: 0.75rem;
        margin: 0.5rem 0;
    }
    .DetailsStep_frequencyOff__GUmk3 {
        font-size: 1.25rem;
    }
    .DetailsStep_detailsContainer__OTQDh {
        height: -moz-fit-content;
        height: fit-content;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Checkout/DetailsStep.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;CAED;IACG,gBAAgB;IAChB;;2BAEuB;AAC3B;;;AAGA;IACI,kBAAkB;IAClB,gGAAgG;AACpG;;AAEA;IACI,cAAc;AAClB;AACA;;GAEG;;AAEH;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;;;;;GAMG;;AAEH;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,gGAAgG;IAChG,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI;QACI,iBAAiB;QACjB,cAAc;QACd,iBAAiB;IACrB;IACA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,0BAA0B;IAC9B;IACA;QACI,cAAc;QACd,qBAAqB;QACrB,aAAa;QACb,sBAAsB;QACtB,uBAAuB;IAC3B;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,uBAAuB;IAC3B;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,iCAAiC;QACjC,oBAAoB;QACpB,oBAAoB;IACxB;IACA;QACI,oBAAoB;QACpB,oBAAoB;IACxB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,wBAAmB;QAAnB,mBAAmB;IACvB;AACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 1/11/2023\r\n */\r\n\r\n .container {\r\n    margin-top: 2rem;\r\n    /* width: 1500px;\r\n    margin-left: -170px;\r\n    margin-right: -200px; */\r\n}\r\n\r\n\r\n.paper {\r\n    padding: 1rem 1rem;\r\n    background: linear-gradient(91deg, rgba(90, 155, 216, 0.1) 23.22%, rgba(90, 155, 216, 0) 99.28%);\r\n}\r\n\r\n.detailsContainer {\r\n    overflow: auto;\r\n}\r\n/* .detailsContainer::-webkit-scrollbar {\r\n    display: none;\r\n} */\r\n\r\n.topic {\r\n    font-size: 1.6rem;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    margin: 0 1.5rem 1.5rem 2.38rem;\r\n}\r\n\r\n.textInput {\r\n    border-radius: 0.5rem;\r\n    background: #FFF;\r\n    box-shadow: 2px 2px 50px 2px #657FAD1A;\r\n}\r\n\r\n.subTitle {\r\n    font-size: 1.25rem;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n}\r\n\r\n.questionContainer {\r\n    margin: 0 2.38rem;\r\n    margin-bottom: 1.5rem;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.line {\r\n    border-color:  rgba(255, 255, 255, 0.5);\r\n    margin: 0;\r\n}\r\n\r\n.itemContainer {\r\n    padding: 1rem 2.38rem;\r\n    display: flex;\r\n    align-items: center;\r\n    /* border-left: 0.3rem solid #f5edff; */\r\n}\r\n\r\n.itemContainerSelected {\r\n    padding: 1.5rem 2.38rem;\r\n    display: flex;\r\n    align-items: center;\r\n    border-radius: 0.5rem;\r\n    background-color: #5a9bd860;\r\n    /* border-left: 0.3rem solid #d7b8ff; */\r\n}\r\n\r\n.addButton {\r\n    border-radius: 0.5rem;\r\n    width: 8rem;\r\n    /* margin-top: 5rem; */\r\n}\r\n\r\n.itemImage {\r\n    width: 7rem;\r\n    object-fit: contain;\r\n    margin-right: 2rem;\r\n}\r\n\r\n.itemDescription {\r\n    font-size: 1rem;\r\n    font-style: normal;\r\n    font-weight: 300;\r\n    margin: 1rem 0;\r\n    width: 26rem;\r\n}\r\n\r\n.itemPrice {\r\n    font-size: 1.5rem;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n}\r\n\r\n.counter {\r\n    color: maroon;\r\n    display: inline-flex;\r\n    margin-left: 2rem;\r\n    height: 2.5rem;\r\n}\r\n\r\n/* .counter button {\r\n    color: black;\r\n    border-radius: 100%;\r\n    font-size: 1.5rem;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n} */\r\n\r\n.instructionContainer {\r\n    margin: 0 2.38rem;\r\n}\r\n\r\n.multiline {\r\n    margin: 3rem 0 1.5rem 0;\r\n    border-radius: 0.5rem;\r\n    background: #FFF;\r\n    box-shadow: 2px 2px 50px 2px #657FAD1A;\r\n}\r\n\r\n.frequencyContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.frequencyCard {\r\n    display: flex;\r\n    flex-direction: column;\r\n    color: black;\r\n    border-radius: 0.5rem;\r\n    background: linear-gradient(91deg, rgba(50, 115, 190, 0.2) 23.22%, rgba(50, 115, 190, 0) 99.28%);\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0 2rem;\r\n    margin: 1rem;\r\n    margin-top: 0;\r\n    height: 10rem;\r\n    cursor: pointer;\r\n    border: 1px solid #c5c5c5;\r\n    text-align: center;\r\n}\r\n\r\n.selectedFreq {\r\n    border: 0.2rem solid #5A9BD8;\r\n}\r\n\r\n.frequencyDetails {\r\n    font-size: 1rem;\r\n    font-style: normal;\r\n    font-weight: 300;\r\n    margin: 0.5rem 0;\r\n    width: 16.5rem;\r\n}\r\n\r\n.frequencyOff {\r\n    color: #077965;\r\n    font-size: 1.5rem;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n}\r\n\r\n/* for mobile */\r\n@media (max-width: 770px) {\r\n    .paper {\r\n        padding: 1.5rem 0;\r\n        padding-top: 0;\r\n        background: white;\r\n    }\r\n    .topic {\r\n        font-size: 1.5rem;\r\n        font-weight: 600;\r\n        margin: 0 1.5rem 2rem 1rem;\r\n    }\r\n    .questionContainer {\r\n        margin: 0 1rem;\r\n        margin-bottom: 0.5rem;\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n    }\r\n    .subTitle {\r\n        font-size: 1rem;\r\n    }\r\n    .textInput {\r\n        margin-top: 1rem;\r\n    }\r\n    .itemDescription {\r\n        width: 14rem;\r\n        height: 3rem;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n    .addButton {\r\n        position: absolute;\r\n        right: 1.5rem;\r\n        margin-top: 6rem;\r\n        width: 5rem;\r\n    }\r\n    .itemImage {\r\n        width: 4rem;\r\n    }\r\n    .itemPrice {\r\n        font-size: 1rem;\r\n    }\r\n    .itemContainer {\r\n        border-left: 0.3rem solid #ffffff;\r\n        padding: 1rem 1.5rem;\r\n        padding-left: 0.5rem;\r\n    }\r\n    .itemContainerSelected {\r\n        padding: 1rem 1.5rem;\r\n        padding-left: 0.5rem;\r\n    }\r\n    .counter button {\r\n        font-size: 1.25rem;\r\n    }\r\n    .counter {\r\n        height: 2rem;\r\n    }\r\n    .frequencyCard {\r\n        padding: 0.1rem;\r\n        height: 7rem;\r\n    }\r\n    .frequencyDetails {\r\n        font-size: 0.75rem;\r\n        margin: 0.5rem 0;\r\n    }\r\n    .frequencyOff {\r\n        font-size: 1.25rem;\r\n    }\r\n    .detailsContainer {\r\n        height: fit-content;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DetailsStep_container__PYHMs`,
	"paper": `DetailsStep_paper__QGXK8`,
	"detailsContainer": `DetailsStep_detailsContainer__OTQDh`,
	"topic": `DetailsStep_topic__cg2Uj`,
	"textInput": `DetailsStep_textInput__-FWKx`,
	"subTitle": `DetailsStep_subTitle__0bu3z`,
	"questionContainer": `DetailsStep_questionContainer__GgoDB`,
	"line": `DetailsStep_line__cni-N`,
	"itemContainer": `DetailsStep_itemContainer__d4DU-`,
	"itemContainerSelected": `DetailsStep_itemContainerSelected__WELdg`,
	"addButton": `DetailsStep_addButton__ZiKZ1`,
	"itemImage": `DetailsStep_itemImage__Tuaj1`,
	"itemDescription": `DetailsStep_itemDescription__zoyz+`,
	"itemPrice": `DetailsStep_itemPrice__rzBy3`,
	"counter": `DetailsStep_counter__K97x4`,
	"instructionContainer": `DetailsStep_instructionContainer__vSixb`,
	"multiline": `DetailsStep_multiline__Lp4Id`,
	"frequencyContainer": `DetailsStep_frequencyContainer__Ikdbf`,
	"frequencyCard": `DetailsStep_frequencyCard__R1rQq`,
	"selectedFreq": `DetailsStep_selectedFreq__0L2c8`,
	"frequencyDetails": `DetailsStep_frequencyDetails__aE6PU`,
	"frequencyOff": `DetailsStep_frequencyOff__GUmk3`
};
export default ___CSS_LOADER_EXPORT___;
